export const paymentOptionsLanding = [
  { label: 'Home', url: '/' },
  { label: 'Payment Options', url: '/payment-options' },
];

// LOBs
export const LOB_LIST_ROUTE = '/payment-options/lobs';
export const LOB_ADD_ROUTE = '/payment-options/lobs/new';

export const viewLOBs = [
  ...paymentOptionsLanding,
  { label: 'Lines of Business', url: LOB_LIST_ROUTE },
];

export const addLOB = [...viewLOBs, { label: 'New', url: LOB_ADD_ROUTE }];
export const editLOB = (id) => [
  ...viewLOBs,
  { label: 'Edit', url: `/payment-options/lobs/${id}` },
];

// Payment Methods
export const METHOD_LIST_ROUTE = '/payment-options/methods';
export const METHOD_NEW_ROUTE = '/payment-options/methods/new';

export const viewPaymentMethods = [
  ...paymentOptionsLanding,
  { label: 'Methods', url: METHOD_LIST_ROUTE },
];

export const addPaymentMethod = [
  ...viewPaymentMethods,
  { label: 'New', url: METHOD_NEW_ROUTE },
];
export const editPaymentMethod = (id) => [
  ...viewPaymentMethods,
  { label: 'Edit', url: `${METHOD_LIST_ROUTE}/${id}` },
];

// Currencies
export const CURRENCY_LIST_ROUTE = '/payment-options/currencies';
export const CURRENCY_NEW_ROUTE = '/payment-options/currencies/new';

export const viewCurrencies = [
  ...paymentOptionsLanding,
  { label: 'Currencies', url: CURRENCY_LIST_ROUTE },
];

export const addCurrency = [
  ...viewCurrencies,
  { label: 'New', url: CURRENCY_NEW_ROUTE },
];
export const editCurrency = (id) => [
  ...viewCurrencies,
  { label: 'Edit', url: `${CURRENCY_LIST_ROUTE}/${id}` },
];

// Gateways
export const GATEWAY_LIST_ROUTE = '/payment-options/gateways';
export const GATEWAY_NEW_ROUTE = '/payment-options/gateways/new';

export const viewGateways = [
  ...paymentOptionsLanding,
  { label: 'Gateways', url: GATEWAY_LIST_ROUTE },
];

export const addGateway = [
  ...viewGateways,
  { label: 'New', url: GATEWAY_NEW_ROUTE },
];
export const editGateway = (id) => [
  ...viewGateways,
  { label: 'Edit', url: `${GATEWAY_LIST_ROUTE}/${id}` },
];

// Gateway Mapping
export const GATEWAY_MAPPING_ROUTE = '/payment-options/gateway-mapping';

export const editGatewayMapping = [
  ...paymentOptionsLanding,
  { label: 'Gateway Mapping', url: GATEWAY_MAPPING_ROUTE },
];

// Gateway Properties
export const GATEWAY_PROPERTIES = '/payment-options/gateway-properties';

export const editGatewayProperties = [
  ...paymentOptionsLanding,
  { label: 'Gateway Properties', url: GATEWAY_PROPERTIES },
];

// Tabs
export const TAB_LIST_ROUTE = '/payment-options/tabs';
export const TAB_NEW_ROUTE = '/payment-options/tabs/new';

export const viewTabs = [
  ...paymentOptionsLanding,
  { label: 'Tabs', url: TAB_LIST_ROUTE },
];

export const addTab = [...viewTabs, { label: 'New', url: TAB_NEW_ROUTE }];
export const editTab = (id) => [
  ...viewTabs,
  { label: 'Edit', url: `${TAB_LIST_ROUTE}/${id}` },
];

// Tab Priority
export const TAB_PRIORITY_ROUTE = '/payment-options/tab-priority';

export const editTabPriority = [
  ...paymentOptionsLanding,
  { label: 'Tab Priority', url: TAB_PRIORITY_ROUTE },
];

// Platforms
export const PLATFORM_LIST_ROUTE = '/payment-options/platforms';
export const PLATFORM_NEW_ROUTE = '/payment-options/platforms/new';

export const viewPlatforms = [
  ...paymentOptionsLanding,
  { label: 'Platforms', url: PLATFORM_LIST_ROUTE },
];

export const addPlatform = [
  ...viewPlatforms,
  { label: 'New', url: PLATFORM_NEW_ROUTE },
];
export const editPlatform = (id) => [
  ...viewPlatforms,
  { label: 'Edit', url: `${PLATFORM_LIST_ROUTE}/${id}` },
];

// Property Keys
export const PROPERTY_KEY_LIST_ROUTE = '/payment-options/property-keys';
export const PROPERTY_KEY_NEW_ROUTE = '/payment-options/property-keys/new';

export const viewPropertyKeys = [
  ...paymentOptionsLanding,
  { label: 'Property Keys', url: PROPERTY_KEY_LIST_ROUTE },
];

export const addPropertyKey = [
  ...viewPropertyKeys,
  { label: 'New', url: PROPERTY_KEY_NEW_ROUTE },
];
export const editPropertyKey = (id) => [
  ...viewPropertyKeys,
  { label: 'Edit', url: `${PROPERTY_KEY_LIST_ROUTE}/${id}` },
];

// Contextual Messages
export const CONTEXTUAL_MESSAGES_LIST_ROUTE =
  '/payment-options/contextual-messages';
export const CONTEXTUAL_MESSAGES_NEW_ROUTE =
  '/payment-options/contextual-messages/new';

export const viewContextualMessages = [
  ...paymentOptionsLanding,
  { label: 'Contextual Messages', url: CONTEXTUAL_MESSAGES_LIST_ROUTE },
];

export const addContextualMessages = [
  ...viewContextualMessages,
  { label: 'New', url: CONTEXTUAL_MESSAGES_NEW_ROUTE },
];

// Maintenance Rules
export const MAINTENANCE_RULES_LIST_ROUTE =
  '/payment-options/maintenance-rules';
export const MAINTENANCE_RULES_NEW_ROUTE =
  '/payment-options/maintenance-rules/new';

export const viewMaintenanceRules = [
  ...paymentOptionsLanding,
  { label: 'Maintenance Rules', url: MAINTENANCE_RULES_LIST_ROUTE },
];

export const addMaintenanceRules = [
  ...viewMaintenanceRules,
  { label: 'New', url: MAINTENANCE_RULES_NEW_ROUTE },
];

// Method Matrix
export const METHOD_MATRIX_LIST_ROUTE = '/payment-options/method-matrix';
export const viewMethodMatrix = [
  ...paymentOptionsLanding,
  { label: 'Method Matrix', url: METHOD_MATRIX_LIST_ROUTE },
];
